<fuse-loading-bar></fuse-loading-bar>
<ng-container *transloco="let t">
<fuse-vertical-navigation
    [dir]="lang === 'ar' ? 'rtl' : 'ltr'"
    class="bg-card print:hidden"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="navigation.default"
    [opened]="!isScreenSmall"
    [position]="lang === 'ar' ? 'right' : 'left'"
>        <!-- fuseVerticalNavigationHeader, NOT ...ContentHeader: the latter renders
             inside `.fuse-vertical-navigation-content`, which is the scroll
             container, so the logo and profile scrolled away with the nav items. -->
        <ng-container fuseVerticalNavigationHeader>
            <!-- Real <button>s, not role="button" divs: Chromium keeps :focus-visible
                 on a clicked tabindex div, which left the header ringed + washed until
                 the next click. Buttons also give Enter/Space for free. -->
            <button
                type="button"
                class="flex items-center w-full p-3 pb-0 mt-5 sai-nav-logo"
                [attr.aria-label]="t('Go to dashboard')"
                (click)="navigateToDashboard($event)"
            >
                <div class="w-full flex items-center justify-center">
                    <img
                        class="w-40 dark:hidden"
                        src="assets/images/logo/logo-text.png"
                        alt="SAI"
                    />
                    <img
                        class="hidden dark:block w-40"
                        src="assets/images/logo/logo-text-dark.png"
                        alt="SAI"
                    />
                </div>
                <div class="flex items-center ms-auto"></div>
            </button>
            <button
                *ngIf="canOpenProfile; else profileStatic"
                type="button"
                class="flex flex-col items-center w-full p-3 my-3 sai-nav-profile"
                data-sai-tour="nav-profile"
                [attr.aria-label]="t('Profile')"
                (click)="goToProfile($event)"
            >
                <ng-container
                    *ngTemplateOutlet="profileBody"
                ></ng-container>
            </button>
            <ng-template #profileStatic>
                <div class="flex flex-col items-center w-full p-3 my-3">
                    <ng-container
                        *ngTemplateOutlet="profileBody"
                    ></ng-container>
                </div>
            </ng-template>

            <ng-template #profileBody>
                <div
                    class="relative w-24 h-24 mb-2 rounded-full p-1 shadow-lg sai-logo-avatar"
                    [class.sai-logo-avatar--placeholder]="!companyPhoto"
                >
                    <img
                        class="w-full h-full rounded-full object-cover"
                        *ngIf="companyPhoto"
                        [authSrc]="companyPhoto"
                        [alt]="t('company logo')"
                    />
                    <mat-icon
                        class="sai-logo-avatar__placeholder-icon"
                        *ngIf="!companyPhoto"
                        [svgIcon]="'heroicons_outline:user'"
                    ></mat-icon>
                </div>

                <div
                    class="flex flex-col items-center justify-center w-full mt-2"
                >
                    <div
                        class="w-full whitespace-nowrap text-ellipsis overflow-hidden text-center text-[13px] leading-[20px] font-medium"
                    >
                        {{
                            companyName
                                ? companyName
                                : userRole === "admin"
                                ? "SAI Super Admin"
                                : ""
                        }}
                    </div>
                    <div
                        class="w-full whitespace-nowrap text-ellipsis overflow-hidden text-center text-[13px] leading-[20px] font-normal"
                    >
                        {{ t(roleLabelKey) }}
                    </div>
                </div>
            </ng-template>
        </ng-container>
        <ng-container fuseVerticalNavigationContentFooter> </ng-container>
        <ng-container fuseVerticalNavigationFooter>
            <div class="w-full px-4 py-4 text-center sai-nav-footer">
                <div
                    class="text-sm font-semibold text-gray-500 dark:text-gray-400"
                >
                    {{ t("SAI") }} v{{ appVersion }}
                </div>
                <div
                    class="text-xs text-gray-500 dark:text-gray-400 mt-1 leading-relaxed"
                >
                    {{
                        t("COPYRIGHT_NOTICE", { year: copyrightYear })
                    }}
                </div>
            </div>
        </ng-container>
    </fuse-vertical-navigation>
    <div class="classy-layout__content flex flex-col flex-1 min-w-0 overflow-hidden">
        <div
            class="classy-layout__toolbar relative flex flex-0 items-center justify-between w-full min-h-14 py-3 px-4 sm:px-6 md:px-8 lg:px-10 z-49 shadow dark:shadow-none dark:border-b bg-card print:hidden"
        >
            <button
                mat-icon-button
                (click)="toggleNavigation('mainNavigation')"
            >
                <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
            </button>
            <!-- justify-between on the toolbar (not ms-auto): pins icons to inline-end in LTR and RTL. -->
            <div class="flex items-center gap-1 sm:gap-3 md:gap-4">
                <!-- Global search is hidden for now; uncomment the <search> tag to bring it back.
                     Docked field where the toolbar can host it; below `md` the icon
                     cluster leaves no room for a field wide enough to read, so search
                     collapses to its icon and expands over the bar instead.
                <search [appearance]="isScreenSmall ? 'bar' : 'basic'"></search>
                -->
                @if (showDarkMode) {
                <button mat-icon-button (click)="toggleTheme()" [matTooltip]="isDark ? t('Light mode') : t('Dark mode')"
                    [attr.aria-label]="t('Toggle dark mode')">
                    <mat-icon [svgIcon]="isDark ? 'heroicons_outline:moon' : 'heroicons_outline:sun'"></mat-icon>
                </button>
                }

                <ng-container
                    *ngIf="userRole !== 'admin' && userRole !== 'chatting'"
                >
                    <messages></messages>
                </ng-container>
                <languages *ngIf="showArabicLanguage"></languages>
                <fuse-fullscreen class="block"></fuse-fullscreen>
                <user [showAvatar]="false"></user>
            </div>
        </div>
        <div class="classy-layout__main relative flex flex-col flex-1 min-w-0">
            <router-outlet *ngIf="true"></router-outlet>
        </div>
    </div>
</ng-container>
